import { IMPROVE_CONFIG } from "@/config.js";
import axios from "axios";

export default {
  getCompanies: function(params,search,state,lead,partnerId ='') {
    return axios.get(IMPROVE_CONFIG.API_URL + "/companies" + params + search + state + lead + partnerId);
  },
  getCustomers: function(params,search,state) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/getcustomers" + params + search + state);
  },
  getCompany: function(params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/company" + params);
  },
  getCompanyById: function(id, params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/companies/" + id + params);
  },
  adminGetCompany: function(id, params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/admin/company/" + id + params);
  },
  getCompanyDetails: function(params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/company/details" + params);
  },
  getAccountInfo: function() {
    return axios.get(IMPROVE_CONFIG.API_URL + "/company/account-info");
  },
  upgradeAccount: function(company_id, banding, package_id, modules, unselectedCourseNames, maxCourse) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/company/banding", {
      company_id: company_id,
      banding: typeof banding === 'object' ? banding.id : '',
      package: package_id,
      modules: modules,
      removed_courses: unselectedCourseNames,
    });
  },
  getAccountState: function() {
    return axios.get(IMPROVE_CONFIG.API_URL + "/companys/account-status");
  },
  updateCompany: function(company, s3 = null, file = null) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/company/details", {
      company_name: company.company_name,
      street: company.street,
      city: company.city,
      county: company.county,
      country: company.country,
      postcode: company.postcode,
      phone: company.phone,
      company_logo: file,
      s3_url: s3,
      theme_color: company.theme_color,
      allow_theme_customization: company.allow_theme_customization
    });
  },
  updateCompanyState: function(id,user_id = '', type='') {
    return axios.post(IMPROVE_CONFIG.API_URL + "/company/state/" + id, {
      user_id: user_id,
      type: type,
      state: type
    });
  },
  extendTrialPeriod: function(date, id) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/company/extend-trial-period/" + id, {
      date: date
    });
  },
  updateCompanyTrial: function(id,date) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/company/trial", {
      expiry_date: date,
      id:id
    });
  },
  resetWelcomeEmail: function(id){
    return axios.post(IMPROVE_CONFIG.API_URL + "/reset/welcome-email", {
      id: id
    });
  },
  getErrorLogs: function(){
    return axios.get(IMPROVE_CONFIG.API_URL + "/user-error-logs?limit=10&container=User");
  },
  updateCompanyInformation: function(company) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/company/information", {
      company_name: company.company_name,
      street: company.street,
      city: company.city,
      country: company.country,
      postcode: company.postcode,
    });
  },
  getCertificate: function () {
    return axios.get(IMPROVE_CONFIG.API_URL + "/certificate");
  },
  addUpdateCertificate: function (s3,file,certificateHtml, certificateStyle) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/company/certificate", {
      s3_url: s3,
      file: file,
      certificateHtml: certificateHtml,
      certificateStyle: certificateStyle
    });
  },
  getFullPlatformReport: function (companyId, partnerId) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/export-full-report", {
      companyId: companyId,
      partnerId: partnerId
    });
  },
  getCompanySites: function(){
    return axios.get(IMPROVE_CONFIG.API_URL + "/sites");
  },
  createSite: function(site){
    return axios.post(IMPROVE_CONFIG.API_URL + "/create-site", {
      name: site.name,
    });
  },
  updateSite: function(site){
    return axios.post(IMPROVE_CONFIG.API_URL + "/update-site", site);
  },
  deleteSite: function(id){
    return axios.delete(IMPROVE_CONFIG.API_URL + "/delete-site/" + id);
  },
  previewCertificate: function(certificateHTML){
    return axios.post(IMPROVE_CONFIG.API_URL + '/preview-certificate',{
      certificateHTML: certificateHTML
    },{responseType: 'blob'});
  },
  getAllBandings: function(){
    return axios.get(IMPROVE_CONFIG.API_URL + "/get-all-banding");
  },
  updateLeadFrom: function (id, leadFrom){
    return axios.post(IMPROVE_CONFIG.API_URL + "/company/lead_from",{
      id: id,
      lead_id: leadFrom,
    });
  },
  fileSign: function (file){
    return axios.post(IMPROVE_CONFIG.API_URL + "/sign",{
      filePath: file.name,
      contentType: file.type,
      type: 'company-logo'
    });
  },
  getPartnerBandings: function(){
    return axios.get(IMPROVE_CONFIG.API_URL + "/get-partner-banding");
  },
  getPartnerBandingPackages: function(bandingId){
    return axios.get(IMPROVE_CONFIG.API_URL + "/get-partner-banding-package/"+bandingId);
  },
  getCompanySettings: function(company_id,isPartner=''){
    return axios.get(IMPROVE_CONFIG.API_URL + "/get-company-settings/"+company_id+isPartner);
  },
  saveCompanySettings: function(company_id, settings){
    return axios.post(IMPROVE_CONFIG.API_URL + "/save-company-settings/"+company_id,{
        notification_customization: settings.notification_customization ?? false,
        theme_customization: settings.theme_customization ?? false,
        is_partner: settings.is_partner ?? false
      });
  },
  updateCompanyRenewal: function(id,date,invoice_type) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/company/renewal", {
      renewal_date: date,
      id:id,
      invoice_type: invoice_type,
    });
  },
  getOnboardingProgress: function() {
    return axios.get(IMPROVE_CONFIG.API_URL + "/company/onboarding-progress");
  },
  updateOnboardingProgress: function(payload) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/company/onboarding-progress", payload);
  },
};
